import { defineComponent } from "vue";
import { defineOgImageScreenshot } from "#imports";
export default defineComponent({
  name: "OgImageScreenshot",
  async setup(_, { attrs }) {
    if (process.server)
      await defineOgImageScreenshot(attrs);
    return () => null;
  }
});
